import axios from 'axios';
import { Kapsule } from '../types/Kapsule';
import { formatToLocale, stringToUTC } from '../utils/dateUtils';
import { KAPTAIN_URL } from './config';

export const getKapsules = async (): Promise<Kapsule[]> => {
  const response = await axios.get<Kapsule[]>(`${KAPTAIN_URL}/api/kapsule`);
  const raw = response.data;
  return raw.map((item) => {
    return {
      ...item,
      createdAt: formatToLocale(stringToUTC(item.createdAt), item.dateFormat ? item.dateFormat : 'yyyy-MM-dd'),
      updatedAt: formatToLocale(stringToUTC(item.updatedAt), item.dateFormat ? item.dateFormat : 'yyyy-MM-dd'),
    };
  });
};

export const deleteKapsules = async (kapsuleIds: string[]): Promise<void> => {
  await axios.delete(`${KAPTAIN_URL}/api/kapsule`, {
    data: { kapsuleIds },
  });
};
